import { produce } from 'immer';
import { CLEAR_PLAYER_INFO_STATE, SET_LOADING_USERNAME, SET_PLAYER_INFO, UPDATE_PLAYER_BLOCKING_FROM_INBOUND } from '../actions/playerInfoActions';
const initialState = {
    loadingUsername: null
};
const playerInfoReducer = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case CLEAR_PLAYER_INFO_STATE: {
                return initialState;
            }
            case SET_LOADING_USERNAME: {
                draft.loadingUsername = action.payload;
                break;
            }
            case SET_PLAYER_INFO: {
                draft.playerInfo = action.payload;
                draft.loadingUsername = null; // loading is done
                break;
            }
            case UPDATE_PLAYER_BLOCKING_FROM_INBOUND: {
                const draftPlayerInfo = draft.playerInfo;
                if (draftPlayerInfo && draftPlayerInfo.playerIdName.id === action.payload.playerId) {
                    // active player info is the one being updated
                    Object.keys(action.payload.blockingTypesToUpdate).forEach((blockingTypeString) => {
                        const blockingType = blockingTypeString;
                        const isBlocking = action.payload.blockingTypesToUpdate[blockingType];
                        if (isBlocking) {
                            // this blocking type is specifically being added (now being blocked) so add it to the array if not already there:
                            if (!draftPlayerInfo.blockingTypes.includes(blockingType)) {
                                draftPlayerInfo.blockingTypes.push(blockingType);
                            }
                        }
                        else {
                            // this blocking type is specifically being removed (no longer being blocked) so remove it from the array:
                            draftPlayerInfo.blockingTypes = draftPlayerInfo.blockingTypes.filter((currBlockingType) => currBlockingType !== blockingType);
                        }
                    });
                }
                break;
            }
        }
    });
};
export default playerInfoReducer;
